import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import Withdraw from './Withdraw';
import ManualWithdraw from './ManualWithdraw';
import styles from './WithdrawTabs.module.scss';
import { useAppSelector } from 'store/hooks';

const WithdrawTabs: React.FC = () => {
  const [tabValue, setTabValue] = useState(0);
  const { total } = useAppSelector((state) => state.transactions.pendingWithdraw);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <Box className={styles.container}>
      <Box className={styles.tabsWrapper}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          className={styles.tabs}
          TabIndicatorProps={{ className: styles.indicator }}
        >
          <Tab label="Withdrawals" className={styles.tab} disableRipple />
          <Tab
            label={
              <Box className={styles.labelWrapper}>
                <span>Manual Withdraw</span>
                {total > 0 && <Box className={styles.badge}>{total}</Box>}
              </Box>
            }
            className={styles.tab}
            disableRipple
          />
        </Tabs>
      </Box>

      <Box className={styles.content}>
        {tabValue === 0 && <Withdraw />}
        {tabValue === 1 && <ManualWithdraw />}
      </Box>
    </Box>
  );
};

export default WithdrawTabs;
